<template>
  <form action="#user-login" @submit.prevent="attemptLogin">
    <loader-box v-if="loading"/>
    <div class="alert" :class="type" v-if="errors.length > 0">
      {{ message }}
    </div>
    <div class="form-group" :class="{'has-error': hasError('phone_number')}">
      <input type="text" class="form-control bg-ash" name="phone_number"
             placeholder="Numéro de téléphone..." v-model="user.phone_number">
      <p class="help-block" v-if="hasError('phone_number')">
        <strong>{{ getError('phone_number') }}</strong>
      </p>
    </div>
    <div class="form-group" :class="{'has-error': hasError('password')}">
      <input type="password" class="form-control bg-ash" name="password" placeholder="Mot de passe..."
             v-model="user.password">
      <p class="help-block" v-if="hasError('password')">
        <strong>{{ getError('password') }}</strong>
      </p>
    </div>
    <div class="checkbox">
      <label>
        <input type="checkbox" name="remember" v-model="user.remember">Se souvenir de moi
      </label>
      <a class="forgotPass clearfix" href="/password/request">Mot de passe oublié ?</a>
    </div>
    <button type="submit" class="btn btn-block btn-primary">Se connecter</button>
  </form>
  <!--<div class="or">-->
  <!--or-->
  <!--</div>-->
  <!--<a class="btn btn-default btnSocial" href="#">Se connecter via facebook</a>-->
</template>

<script>
  import LoaderBox from '../Loader/LoaderBox.vue'
  import appAxios from '../../app-axios'
  import AppApiResponse from "../../AppApiResponse";

  export default {
    name: 'user-login',
    components: {LoaderBox},
    props: {
      url: String,
      userHomeUrl: {type: String, default: ''}
    },
    data () {
      return {
        loading: false,
        user: {
          phone_number: '',
          password: '',
          remember: false,
        },
        errors: {},
        type: '',
        message: ''
      }
    },
    methods: {
      hasError (key) {
        return this.errors.hasOwnProperty(key)
      },
      getError (key) {
        return this.errors[key][0]
      },
      attemptLogin () {
        this.type = ''
        this.message = ''
        this.loading = true
        this.errors = {}
        appAxios.post(this.url, this.user)
          .then(apiResponse => {
            this.type = apiResponse.getType()
            this.message = apiResponse.getMessage()
            this.message += ' Redirection en cours...'
            let user = apiResponse.getData()
            let index = index = window.location.search.indexOf('u')
            if (index !== -1) {
              let parts = window.location.search.substring(index).split('=')
              if (parts.length > 1) {
                window.location = parts[1]
              } else {
                window.location = this.userHomeUrl.replace(':user', user.id)
              }
            } else {
              window.location = window.location.pathname.includes('/user/login') ? this.userHomeUrl.replace(':user', user.id) : window.location.href
            }
          })
          .catch(apiResponse => {
            console.error(apiResponse)
            if (apiResponse instanceof AppApiResponse) {
              this.errors = Object.assign({}, this.errors, apiResponse.getData())
              this.type = apiResponse.getType()
              this.message = apiResponse.getMessage()
            }
          })
          .then(_ => this.loading = false)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// resources/assets/js/component/User/UserLogin.vue